import { mediaURLGQLFields } from './mediaURL.fields.js';
export function imageGQLFields() {
    return `
    __typename
    id
    url
    width
    height
    dominantColorHex
    dpi
    cropHeight
    cropWidth
    cropX
    cropY
    cropZoom
    urls {
      ${mediaURLGQLFields()}
    }
  `;
}
//# sourceMappingURL=image.fields.js.map